// src/contexts/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Create axios instance


  // Auto-add Bearer token
  api.interceptors.request.use(config => {
    const token = localStorage.getItem('bearer_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Try to restore session on app load
  useEffect(() => {
    const token = localStorage.getItem('bearer_token');
    if (!token) {
      setLoading(false);
      return;
    }

    api.get('/me')
      .then(res => {
        setUser(res.data.user || res.data.data || res.data);
      })
      .catch(() => {
        localStorage.removeItem('bearer_token');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/login', { email, password });
    const token = res.data.token;
    localStorage.setItem('bearer_token', token);

    const me = await api.get('/me');
    setUser(me.data.user || me.data.data || me.data);
    return me.data.data;
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (err) {
      console.warn('Logout failed (maybe token expired)');
    }
    localStorage.removeItem('bearer_token');
    setUser(null);
    // Navigate via window (safe outside Router)
    window.location.href = '/login';
  };

  // Optional: Dev mode — auto-login as test customer
  // Remove this block in production
  // useEffect(() => {
  //   if (process.env.REACT_APP_API_URL && !localStorage.getItem('bearer_token')) {
  //     // Uncomment one to auto-login during development:
      
  //     // Test Customer
  //     // localStorage.setItem('bearer_token', 'your-jwt-here');
      
  //     // Or just skip auth entirely for now:
  //     setUser({
  //       id: 1,
  //       name: "Test Customer",
  //       first_name: "Chioma",
  //       email: "customer@test.com",
  //       profile_type: "customer"
  //     });
  //     setLoading(false);
  //   }
  // }, []);

  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      login,
      logout,
      loading,
      api,
      isAuthenticated: !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  console.log('AuthContext:', context);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};